"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../util");
// 无需上报的属性-success状态的retcode
var ignorableAttrName = '0';
var bigCollab = 'big-collab';
var name = 'collab';
var CollabRoomReporter = /** @class */ (function () {
    function CollabRoomReporter() {
        try {
            if (!window.Aegis)
                return;
            this.aegis = new window.Aegis({
                id: 'SDK-9818a6f1a4d99eacc267',
                hostUrl: {
                    // 伽利略上报地址
                    url: 'https://galileotelemetry.tencent.com/collect',
                },
                // 发布的版本（分支）
                version: window.__globalReleaseVersion,
                useAid: true,
                // 不抽样
                speedSample: false,
                reportApiSpeed: false,
                reportAssetSpeed: false,
                pagePerformance: false,
                plugin: {
                    pv: false,
                    aid: true,
                    error: false,
                    device: false,
                    close: false,
                    pagePerformance: false,
                    webVitals: false,
                    fId: false,
                    ie: true,
                    spa: false,
                    api: false,
                    apiSpeed: false,
                    assetSpeed: false,
                },
            });
        }
        catch (error) {
            util_1.ConnectionLog.warn("CollabRoomReporter init error:" + (error === null || error === void 0 ? void 0 : error.message));
        }
    }
    /**
     * 房间层登录异常信息
     *
     * @param {IReportMessage} message
     * @return {*}  {void}
     */
    CollabRoomReporter.prototype.loginRoomError = function (message) {
        if (this.needToResetLastErrorCode(message)) {
            this.resetLastErrorCode();
            return;
        }
        this.lastAttrName = message.attrName;
        this.reportToServer(__assign(__assign({}, message), { source: 'loginRoom' }));
    };
    /**
     * 提交数据异常
     *
     * @param {IReportMessage} message
     * @return {*}  {void}
     */
    CollabRoomReporter.prototype.commitError = function (message) {
        // 空消息或者retcode === 0 都返回
        if (this.needToResetLastErrorCode(message)) {
            this.resetLastErrorCode();
            return;
        }
        this.lastAttrName = message.attrName;
        this.reportToServer(__assign(__assign({}, message), { source: 'commitError' }));
    };
    /**
     * 服务器推送消息
     *
     * @param {IReportMessage} message
     * @return {*}  {void}
     */
    CollabRoomReporter.prototype.serverNotice = function (message) {
        // 空消息或者retcode === 0 都返回
        if (this.needToResetLastErrorCode(message)) {
            this.resetLastErrorCode();
            return;
        }
        this.lastAttrName = message.attrName;
        this.reportToServer(__assign(__assign({}, message), { source: 'serverNotice' }));
    };
    /**
     * 上报业务层断开主动连接
     *
     * @param {IReportMessage} message
     * @return {*}  {void}
     */
    CollabRoomReporter.prototype.shutDownReport = function (message) {
        // 空消息或者retcode === 0 都返回
        if (this.needToResetLastErrorCode(message) || message.attrName === this.lastAttrName) {
            this.resetLastErrorCode();
            return;
        }
        this.reportToServer(__assign(__assign({}, message), { source: 'shutDown' }));
    };
    CollabRoomReporter.prototype.reconnectReport = function (message) {
        this.reportToServer(__assign(__assign({}, message), { source: 'reconnect', transports: bigCollab }));
    };
    CollabRoomReporter.prototype.retryRequestReport = function (error, module) {
        this.reportToServer({
            attrName: error.name,
            module: module,
            errorMessage: error.message,
            status: 1 /* FAILED */,
            source: 'retryRequest',
            transports: bigCollab,
        });
    };
    CollabRoomReporter.prototype.receiverParseError = function (errorMessage, module) {
        this.reportToServer({
            attrName: 'receiver-parse-error',
            module: module,
            errorMessage: errorMessage,
            status: 1 /* FAILED */,
            source: 'receiver-parse-error',
            transports: bigCollab,
        });
    };
    /**
     * socket连接信息上报
     *
     * @param {IReportMessage} message
     * @return {*}  {void}
     */
    CollabRoomReporter.prototype.reportSocketConnect = function (message) {
        this.reportToServer(__assign(__assign({}, message), { source: 'socketConnect' }));
    };
    /**
     * 非编辑通道初始化上报
     *
     */
    CollabRoomReporter.prototype.reportUserChannel = function () {
        this.reportToServer({
            attrName: '非编辑通道请求',
            status: 0 /* SUCCESS */,
        });
    };
    /**
     * 统一进行上报
     *
     * @private
     * @param {IReportData} data
     */
    CollabRoomReporter.prototype.reportToServer = function (message) {
        var _a, _b;
        var _c = message.module, module = _c === void 0 ? 'unknown' : _c, _d = message.source, source = _d === void 0 ? '' : _d, _e = message.transports, transports = _e === void 0 ? '' : _e;
        (_b = (_a = this.aegis) === null || _a === void 0 ? void 0 : _a.reportEvent) === null || _b === void 0 ? void 0 : _b.call(_a, {
            name: name,
            eventName: message.attrName,
            status: message.status,
            errorMessage: message.errorMessage,
            documentType: module,
            source: source,
            transports: transports,
        });
    };
    CollabRoomReporter.prototype.resetLastErrorCode = function () {
        this.lastAttrName = '';
    };
    CollabRoomReporter.prototype.needToResetLastErrorCode = function (message) {
        // 空消息或者retcode === '0' 都返回
        if (!(message === null || message === void 0 ? void 0 : message.attrName) || (message === null || message === void 0 ? void 0 : message.attrName) === ignorableAttrName) {
            return true;
        }
        return false;
    };
    return CollabRoomReporter;
}());
exports.default = new CollabRoomReporter();
